import {
  Activity,
  ArrowRightLeft,
  BarChart3,
  BookOpen,
  Bot,
  Boxes,
  Briefcase,
  Building2,
  CalendarDays,
  CheckCircle2,
  ClipboardList,
  Copy,
  FileCheck2,
  FileSignature,
  FileText,
  Filter,
  FolderKanban,
  Gauge,
  LayoutDashboard,
  LayoutTemplate,
  LifeBuoy,
  ListChecks,
  Mail,
  Megaphone,
  MessageCircle,
  Newspaper,
  Palette,
  PlayCircle,
  Plug,
  Radar,
  Rocket,
  Settings,
  ShieldCheck,
  Sparkles,
  UserCog,
  UserPlus,
  Users,
  Wallet,
  Workflow,
  FormInput,
  type LucideIcon,
} from 'lucide-react'

const iconByModule: Record<string, LucideIcon> = {
  clients: Users,
  crm: UserPlus,
  projects: FolderKanban,
  proposals: FileSignature,
  whatsapp_ai: Bot,
  landing_pages: LayoutTemplate,
  campaigns: Megaphone,
  bi_reports: BarChart3,
  automations: Workflow,
  support: LifeBuoy,
  finance: Wallet,
  blueprints: ClipboardList,
  action_engine: Rocket,
  marketing_studio: Sparkles,
  radar: Radar,
}

/** Ícones por endereço, sempre na forma `/portal/...` (ver `normalizeNavigationHref`). */
const iconByHref: Record<string, LucideIcon> = {
  '/portal': LayoutDashboard,
  '/portal/projetos/aprovacoes': CheckCircle2,
  '/portal/projetos/projetos': FolderKanban,
  '/portal/projetos/documentos': FileText,
  '/portal/projetos/propostas': FileSignature,
  '/portal/comercial/leads': UserPlus,
  '/portal/comercial/funis': Filter,
  '/portal/comercial/tarefas': ListChecks,
  '/portal/comercial/contas': Building2,
  '/portal/comercial/scoring': Gauge,
  '/portal/comercial/radar': Radar,
  '/portal/atendimento/conversas': MessageCircle,
  '/portal/atendimento/agente-ia': Bot,
  '/portal/atendimento/canais': Plug,
  '/portal/atendimento/filas-handoff': ArrowRightLeft,
  '/portal/marketing/campanhas': Megaphone,
  '/portal/marketing/landing-pages': LayoutTemplate,
  '/portal/marketing/formularios': FormInput,
  '/portal/marketing/studio': Sparkles,
  '/portal/marketing/conteudo': Newspaper,
  '/portal/marketing/calendario': CalendarDays,
  '/portal/marketing/criativos': Palette,
  '/portal/automacoes/fluxos': Workflow,
  '/portal/automacoes/templates': Copy,
  '/portal/automacoes/execucoes': PlayCircle,
  '/portal/missoes': Rocket,
  '/portal/relatorios': BarChart3,
  '/portal/empresa/perfil': Building2,
  '/portal/empresa/marca': Palette,
  '/portal/empresa/conhecimento': BookOpen,
  '/portal/empresa/usuarios': Users,
  '/portal/empresa/integracoes': Plug,
  '/portal/configuracoes/emails': Mail,
  '/portal/financeiro': Wallet,
  '/portal/suporte': LifeBuoy,
  '/portal/configuracoes/conta': UserCog,
  // Hub interno
  '/admin': ShieldCheck,
  '/admin/integrations': Settings,
  '/admin/email': Mail,
  '/admin/ai': Bot,
  '/admin/health': Activity,
  '/admin/limits': Briefcase,
  '/client-workspaces': Building2,
  '/client-conversions': UserPlus,
  '/contracts': FileCheck2,
  '/packages': Boxes,
  '/modules': LayoutDashboard,
  '/crm-governance': ShieldCheck,
}

/** `/client-workspaces/<id>/x` vira `/portal/x`, para reaproveitar o mesmo mapa de ícones. */
export function normalizeNavigationHref(href: string) {
  return href.replace(/^\/client-workspaces\/[^/]+/, '/portal') || '/portal'
}

export function iconForNavigationItem(item: { href: string; moduleKey?: string }): LucideIcon {
  return iconByHref[normalizeNavigationHref(item.href)]
    ?? (item.moduleKey ? iconByModule[item.moduleKey] : undefined)
    ?? LayoutDashboard
}
